import { createClient } from '@supabase/supabase-js';
import { createDeskOperatorSessionHolder } from '@lemontaigu/platform';
import { deskOperatorFetch } from '@lemontaigu/platform/adapters/client';
import { SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY } from './config.js';

/** The tab's desk session (« Qui êtes-vous ? », DESK-OPERATOR brief §2): every
 *  request below carries it as X-Desk-Operator, so audited writes name the person. */
export const deskOperatorSession = createDeskOperatorSessionHolder(
  (() => {
    try {
      return window.sessionStorage;
    } catch {
      return null;
    }
  })(),
);

export const supabase = createClient(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  global: { fetch: deskOperatorFetch(deskOperatorSession) },
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: false,
  },
});
